'use client';

import { useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useCarousel } from './useCarousel';
import { carouseNavlMessages } from './messages';

export const CarouselNav = () => {
  const { atStart, atEnd, trackRef } = useCarousel();
  const { formatMessage } = useIntl();

  const scrollBySlides = (dir: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const firstChild = el.querySelector<HTMLElement>(':scope > *');
    if (!firstChild) return;
    const slideWidth =
      firstChild.getBoundingClientRect().width + parseFloat(getComputedStyle(el).columnGap || '0');
    // Desktop mimic: default to 5 if width >= 1024
    const isDesktop = window.matchMedia('(min-width:1024px)').matches;
    const count = isDesktop ? 5 : 2;
    el.scrollBy({ left: dir * slideWidth * count, behavior: 'smooth' });
  };

  const onPrev = () => scrollBySlides(-1);
  const onNext = () => scrollBySlides(1);

  const navAriaPrev = formatMessage(carouseNavlMessages.ariaPrevButton);
  const navAriaNext = formatMessage(carouseNavlMessages.ariaNextButton);
  return (
    <>
      {!atStart && (
        <Button
          variant="icon-only"
          size="medium"
          aria-label={navAriaPrev}
          className="bg-color-carousel-dot absolute top-1/2 left-1 z-30 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
          onClick={onPrev}
          disabled={atStart}
        >
          <span className="icon-emp-arrow-medium-left size-4" role="img" />
        </Button>
      )}
      {!atEnd && (
        <Button
          variant="icon-only"
          size="medium"
          aria-label={navAriaNext}
          className="bg-color-carousel-dot absolute top-1/2 right-1 z-30 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
          onClick={onNext}
          disabled={atEnd}
        >
          <span className="icon-emp-arrow-medium-right size-4" role="img" />
        </Button>
      )}
    </>
  );
};
